import { render, staticRenderFns } from "./convert-phone-to-uid.vue?vue&type=template&id=4f33e72e&"
import script from "./convert-phone-to-uid.vue?vue&type=script&lang=js&"
export * from "./convert-phone-to-uid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports